/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useCallback,
  useState,
  useRef,
  useMemo,
  useEffect,
} from "react";
import Text from "@components/CustomText";
import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import {
  cancelRto,
  getQrCodeStatus,
  getUserOrders,
  markMultipleDeliveries,
  markTaskActions,
} from "@services/api";
import color from "@constants/color";
import {
  BackHandler,
  FlatList,
  View,
  StyleSheet,
  ActivityIndicator,
  Modal,
} from "react-native";
import { useFocusEffect } from "@react-navigation/native";
// eslint-disable-next-line import/no-named-as-default
import t from "@constants/localization";
import useLocationHook from "@components/common/LocationHook";
import ConfirmationModalWithImage from "@components/ConfirmationModalWithImage";
import ModalSubmit from "@assets/svg/MyTasks/ModalSubmit";
import ModalCancel from "@assets/svg/MyTasks/ModalCancel";
import ModalCashCollection from "@assets/svg/MyTasks/ModalCashCollected";
import { useDispatch, useSelector } from "react-redux";
import { actions as myTaskActions } from "@reducers/myTaskReducer";
import ToastMessage from "@components/Toast.js";
import CashIcon from "@assets/svg/MyTasks/Cash";
import QRIcon from "@assets/svg/MyTasks/QRIcon";
import InnerDeliveryCard from "./components/InnerDeliveryCard";
import RescheduleRightComponent from "./components/RescheduleRightComponent";
import RescheduleModal from "./components/RescheduleModal";
import MarkingDeliveryModal from "./components/MarkingDeliveryModal";
import BottomButton from "./components/BottomButton";
import InstantCommissionModal from "./OtpVerifcation/InstantCommissionModal";
import BottomPaymentSheet from "./components/BottomPaymentSheet";
import { calculateTotalPayableAmount } from "./utils";
import EmptyBox from "@assets/svg/EmptyBox";

const HeaderStrip = ({ should_deliver_tag }) => (
  <View style={styles.headerStrip}>
    <EmptyBox />
    <Text variant="title_16" style={styles.headerText}>
      {should_deliver_tag}
    </Text>
  </View>
);

function CustomerOrdersView({ navigation, route }) {
  const { orderMarkingMap, orderMarkingSource } = useSelector(
    (state) => state.myTaskReducer,
  );
  const [allData, setAllData] = useState({});
  const [listData, setListData] = useState([]);
  const [isloading, setIsLoading] = useState(true);
  const [isRescheduled, setIsRescheduled] = useState(null);
  const [isPendingDMinus2, setIsPendingDMinus2] = useState(false);
  const [rescheduledModal, setRescheduledModal] = useState(false);
  const isRescheduledCp = useRef(false);
  const [showMarkingModal, setShowMarkingModal] = useState(false);
  const [markingOrder, setMarkingOrder] = useState(null);
  const [showSubmitModal, setShowSubmitModal] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [showCancleMarkingModal, setShowCancleMarkingModal] = useState(false);
  const [showInstantCommissionModal, setShowInstantCommissionModal] =
    useState(false);
  const [commissionMsgs, setCommissionMsgs] = useState("");
  const {
    multiOrderDelivery = false,
    pollingEnable = false,
    pollingInterval = 30,
  } = useSelector(({ configReducer }) => configReducer);
  const [multiDeliveryEnabled, setMultiDeliveryEnabled] = useState(
    multiOrderDelivery || false,
  );

  const [onlinePaymentMetadata, setOnlinePaymentMetadata] = useState({});

  const data = route.params?.data;

  const PATH = "screens/MyTask";

  const isMarking = useRef(false);
  const isProcessingRef = useRef(false);
  const isFirstVisit = useRef(true);
  const isSubmitted = useRef(false);
  const hasNavigatedToOtpRef = useRef(false);
  const cardMarkingBtnRef = useRef(false);
  const getCurrentLocation = useLocationHook();
  const dispatch = useDispatch();
  useFocusEffect(
    useCallback(() => {
      if (
        !isFirstVisit.current &&
        multiDeliveryEnabled &&
        !isSubmitted.current
      ) {
        if (hasNavigatedToOtpRef.current) {
          hasNavigatedToOtpRef.current = false;
        } else if (markingOrder) {
          setShowMarkingModal(true);
        }
      } else {
        isFirstVisit.current = false;
        dispatch(myTaskActions.clearOrderMarking());
      }
      fetchData();
    }, [markingOrder]),
  );
  useFocusEffect(
    useCallback(() => {
      const backHandlerSub = BackHandler.addEventListener(
        "hardwareBackPress",
        backHandler,
      );

      return () => {
        backHandlerSub.remove();
      };
    }, [orderMarkingMap]),
  );
  useEffect(() => {
    if (!pollingEnable) return;
    let intervalId = null;
    const checkStatus = async () => {
      await getPaymentStatus();
    };
    if (
      Object.keys(orderMarkingMap).length > 0 &&
      allData?.online_payment_enabled &&
      (onlinePaymentMetadata?.payment_status === "CREATED" ||
        onlinePaymentMetadata?.payment_status === "PENDING")
    ) {
      intervalId = setInterval(checkStatus, pollingInterval * 1000);
    }
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    };
  }, [onlinePaymentMetadata, orderMarkingMap]);
  const backHandler = () => {
    if (
      Object.keys(orderMarkingMap).length > 0 &&
      Object.values(orderMarkingMap).some(
        (item) =>
          item?.key === "CANCEL_DELIVERY" || item?.key === "CONFIRM_DELIVERY",
      ) &&
      onlinePaymentMetadata?.is_marking_enabled
    ) {
      setShowCancleMarkingModal(true);
      return true;
    }
    dispatch(myTaskActions.clearOrderMarking());
    return false;
  };

  const showQrPaymentOption = useMemo(
    () => allData?.multi_order_delivery && allData?.online_payment_enabled,
    [allData],
  );
  const isOrderMarkingMapEmpty = () => {
    return Object.keys(orderMarkingMap).length === 0;
  };
  const getTabStatus = () => {
    let status = null;
    if (data.card_status === "DELIVERY" && data.data_type === "TODAY") {
      status = "pending";
    }
    if (data.card_status === "RESCHEDULED" && data.data_type === "TODAY") {
      status = "rescheduled";
    }
    return status;
  };

  const markingAction = async ({ action, reason }) => {
    try {
      if (!isMarking.current) {
        isMarking.current = true;
        const payload = {
          action,
          cx_id: data.user_id,
          status: "",
          pending_order_ids:
            data?.to_be_delivered_ids || data?.delivery_pending_order_ids || [],
          reason,
          is_d_minus_2: isPendingDMinus2,
        };
        payload.status = getTabStatus();
        if (
          payload.action &&
          payload.cx_id &&
          payload.status &&
          payload.reason
        ) {
          const response = await markTaskActions(payload);
          isMarking.current = false;
          // Reschedule may be OTP-gated server-side (HTTP 200, body.status=412).
          if (response?.data?.payload?.error === "OTP_VERIFICATION_FAILED") {
            const p = response.data.payload;
            navigation.navigate("RescheduleOTPVerification", {
              otpLength: p.otpLength,
              otpText: p.errorText,
              phone_numbers: p.phone_numbers || [],
              taskPayload: payload,
              popCount: 2,
            });
            return;
          }
          navigation.goBack();
          return;
        }
        isMarking.current = false;
        navigation.goBack();
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
      isMarking.current = false;
    }
  };
  const onRefresh = () => {
    setIsRefreshing(true);
    getPaymentStatus();
    setIsRefreshing(false);
  };
  const getPaymentStatus = async () => {
    try {
      const res = await getQrCodeStatus({
        cx_id: data?.user_id,
        otp_enabled: allData?.otp_enabled,
        order_ids: orderMarkingMap,
      });
      setOnlinePaymentMetadata(res?.data?.online_payment_metadata);
      if (
        allData?.online_payment_enabled &&
        res?.data?.online_payment_metadata &&
        res?.data?.online_payment_metadata?.payment_status !== "INITIAL"
      ) {
        dispatch(
          myTaskActions.addBulkOrdersMarking(
            res?.data?.online_payment_metadata?.order_marking_map,
            "api",
          ),
        );
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };
  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res = await getUserOrders({
        user_id: data?.user_id,
        data_type: data?.data_type,
        db_id: data?.db_id,
        route_id: data?.route_id,
        // Scope the list to the tapped card. The backend stamps trip_id only
        // on a card that has a trip, so its absence means the trip-less
        // pending card -> PENDING. Without this, a customer with a pending
        // card and a trip card shows both cards' orders on either drill-in.
        // Flag-OFF CPs have no trips, so PENDING returns every order.
        trip_id: data?.trip_id ?? "PENDING",
      });
      isRescheduledCp.current = res?.data?.isRescheduledCp || false;
      setAllData(res?.data);
      setListData(res?.data?.tasks);
      setMultiDeliveryEnabled(res?.data?.multi_order_delivery);
      setOnlinePaymentMetadata(res?.data?.online_payment_metadata);
      res?.data?.tasks?.forEach((item) => {
        if (
          item?.card_type === "DELIVERED" ||
          item?.card_type === "RTO_CAN_CANCEL" ||
          item?.card_type === "RTO_CANNOT_CANCEL"
        ) {
          const value = {
            key: getActionKeyfn(item?.card_type),
            reason: null,
            order_id: item?.order_ids[0],
          };
          dispatch(
            myTaskActions.addOrderMarking(item?.order_ids[0], value, "api"),
          );
        }
        if (item?.order_items_count === 0) {
          const value = {
            key: "ALL_ISSUES",
            reason: null,
            order_id: item?.order_ids[0],
          };
          dispatch(
            myTaskActions.addOrderMarking(item?.order_ids[0], value, "api"),
          );
        }
      });
      if (
        res?.data?.online_payment_enabled &&
        res?.data?.online_payment_metadata &&
        res?.data?.online_payment_metadata?.payment_status !== "INITIAL"
      ) {
        dispatch(
          myTaskActions.addBulkOrdersMarking(
            res?.data?.online_payment_metadata?.order_marking_map,
            "api",
          ),
        );
      }
      if (getTabStatus()) {
        setIsRescheduled(res?.data?.any_rescheduled);
      }
      setIsPendingDMinus2(res?.data?.any_pending_d_minus_2);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const prepaidOrdersMap = useMemo(() => {
    const ordersMap = {};
    listData.forEach((task) => {
      if (Array.isArray(task?.order_ids) && task?.all_prepaid_orders) {
        task.order_ids.forEach((orderId) => {
          ordersMap[orderId] = task?.all_prepaid_orders;
        });
      }
    });
    return ordersMap;
  }, [listData]);

  function getActionKeyfn(card_type) {
    if (card_type === "DELIVERED") {
      return "DELIVERED_TO_CX";
    } else if (
      card_type === "RTO_CAN_CANCEL" ||
      card_type === "RTO_CANNOT_CANCEL"
    ) {
      return "CX_RTO";
    }
    return "";
  }
  const totalPayableAmount = useMemo(
    () => calculateTotalPayableAmount(listData, orderMarkingMap),
    [listData, orderMarkingMap],
  );

  const handleNavigation = async (paymentMode = "COD") => {
    let deliverySucceeded = false;
    try {
      if (isProcessingRef.current) return;
      isProcessingRef.current = true;
      const coords = await getCurrentLocation(2);
      const payload = {
        orders: Object.values(orderMarkingMap),
        otp: "",
        lat: coords.latitude,
        lng: coords.longitude,
        otp_enabled: allData?.otp_enabled,
        online_payment_enabled: allData?.online_payment_enabled,
        collectible_amount: parseFloat(totalPayableAmount),
        cx_user_id: listData[0]?.user_id,
        status: onlinePaymentMetadata?.status,
        amount: onlinePaymentMetadata?.amount,
        paytm_order_id: onlinePaymentMetadata?.paytm_order_id,
        payment_mode: paymentMode,
      };
      const response = await markMultipleDeliveries(payload);
      if (response?.data?.payload?.error === "OTP_VERIFICATION_FAILED") {
        hasNavigatedToOtpRef.current = true;
        return navigation.navigate("NewOTPVerification", {
          otpLength: response?.data?.payload?.otpLength || 4,
          otpText: response?.data?.payload?.otpText || "",
          online_payment_enabled: allData?.online_payment_enabled,
          collectible_amount: totalPayableAmount,
          cx_user_id: listData[0]?.user_id,
          paymentMode,
          phone_numbers: response?.data?.payload?.phone_numbers || [],
          extra_info: response?.data?.payload?.extra_info || "",
          status: onlinePaymentMetadata?.status,
          amount: onlinePaymentMetadata?.amount,
          paytm_order_id: onlinePaymentMetadata?.paytm_order_id,
        });
      }
      if (response.status === 200) {
        deliverySucceeded = true;
        dispatch(myTaskActions.clearOrderMarking());
        if (response?.data?.type === "INSTANT_COMMISSION_TRIGGERED") {
          setCommissionMsgs(response?.data);
          setShowInstantCommissionModal(true);
          return;
        }
        ToastMessage("success", response?.data?.payload?.toastMessage);
      }
      fetchData();
      return navigation.pop();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("error", error);
    } finally {
      setShowSubmitModal(false);
      isProcessingRef.current = false;
      if (deliverySucceeded) isSubmitted.current = true;
    }
  };

  const handlePaymentNavigation = async (paymentMode) => {
    let navigatedToQrPayment = false;
    try {
      if (paymentMode === "COD") {
        if (!showSubmitModal && !allData?.otp_enabled) {
          setShowSubmitModal(true);
        } else {
          setShowSubmitModal(false);
          handleNavigation(paymentMode);
        }
      } else {
        navigatedToQrPayment = true;
        const cx_id = data?.user_id;
        const payable_amount = totalPayableAmount;
        return navigation.navigate("CPCXQRPayment", {
          cx_id,
          payable_amount,
          otp_enabled: allData?.otp_enabled,
        });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("error", error);
    } finally {
      if (navigatedToQrPayment) isSubmitted.current = true;
    }
  };
  const onButtonPress = async (key, item) => {
    try {
      if (cardMarkingBtnRef.current) return;
      cardMarkingBtnRef.current = true;
      if (multiDeliveryEnabled) {
        if (key === "CANCEL_RTO") {
          const payload = {
            return_req_ids: item?.return_req_ids,
          };
          await cancelRto(payload);
          fetchData();
        } else if (key === "CONFIRM_DELIVERY" || key === "CANCEL_DELIVERY") {
          setMarkingOrder({ ...item, key });
          setShowMarkingModal(true);
        }
      } else {
        if (key === "CONFIRM_DELIVERY") {
          return navigation.navigate("PreDeliveryItemList", {
            orders_list: item?.order_ids,
            spoke_name: "",
            date: "",
            user_name: item?.user_name,
            user_id: item?.user_id,
            user_phone: item?.user_phone,
            is_delivery: true,
            afterOtpRedirectScreenName: "MyTask",
            type: "CONFIRM_DELIVERY",
          });
        } else if (key === "CANCEL_DELIVERY") {
          return navigation.navigate("PreDeliveryItemList", {
            orders_list: item?.order_ids,
            spoke_name: "",
            date: "",
            user_name: item?.user_name,
            user_id: item?.user_id,
            user_phone: item?.user_phone,
            is_delivery: false,
            type: "CANCEL_DELIVERY",
          });
        } else if (key === "CANCEL_RTO") {
          const payload = {
            return_req_ids: item?.return_req_ids,
          };
          await cancelRto(payload);
          fetchData();
        }
      }
    } catch {
    } finally {
      cardMarkingBtnRef.current = false;
    }
  };
  const onMarkingOrder = (orderId, value) => {
    if (value) {
      dispatch(myTaskActions.addOrderMarking(orderId, value, "button"));
    } else {
      dispatch(myTaskActions.removeOrderMarking(orderId));
    }
  };
  const checkAllCxRTO = () => {
    if (
      Object.keys(orderMarkingMap).length === 0 ||
      Object.keys(orderMarkingMap).length < listData.length
    ) {
      return false;
    }
    let val = true;
    Object.values(orderMarkingMap).forEach((item) => {
      if (item?.key === "CONFIRM_DELIVERY") {
        val = false;
      }
    });
    return val;
  };
  const checkAllCODCxRTO = () => {
    if (
      Object.keys(orderMarkingMap).length === 0 ||
      Object.keys(orderMarkingMap).length < listData.length
    ) {
      return false;
    }
    let val = true;
    Object.values(orderMarkingMap).forEach((item) => {
      if (!prepaidOrdersMap[item?.order_id]) {
        if (item?.key === "CONFIRM_DELIVERY") {
          val = false;
        }
      }
    });
    return val;
  };
  const getSubmitBtnText = useCallback(() => {
    if (allData?.otp_enabled) {
      if (!checkAllCxRTO()) {
        return t(`${PATH}/submit_with_otp`);
      }
      return t(`${PATH}/submit`);
    }
    return t(`${PATH}/submit`);
  }, [orderMarkingMap, allData?.otp_enabled]);
  const renderItem = useCallback(
    ({ item }) => {
      return (
        <InnerDeliveryCard
          item={item}
          onPressBtn={onButtonPress}
          orderMarkingMap={orderMarkingMap}
          onMarkingOrder={onMarkingOrder}
          cardMarkingBtnRef={cardMarkingBtnRef}
          changeMarkingEnabled={onlinePaymentMetadata?.is_marking_enabled}
        />
      );
    },
    [
      orderMarkingMap,
      multiDeliveryEnabled,
      onlinePaymentMetadata?.is_marking_enabled,
    ],
  );
  const onSubmit = () => {
    setShowSubmitModal(true);
  };
  const modalImage = (type) => {
    switch (type) {
      case "submit":
        return <ModalSubmit />;
      case "cancel":
        return <ModalCancel />;
      case "cash":
        return <ModalCashCollection />;
      default:
        return <ModalSubmit />;
    }
  };
  const closemarkingModal = async () => {
    setShowMarkingModal(false);
    await fetchData();
  };
  const footerComponent = () => <View style={styles.footer} />;

  const plasticBagCount = Number(allData?.plastic_bag_count) || 0;
  const plasticBagBanner =
    allData?.plastic_bag_opted_in && plasticBagCount > 0 ? (
      <View style={styles.plasticBagBanner}>
        <Text variant="body_text_2" style={styles.plasticBagText}>
          {`${plasticBagCount} पॉली बैग ज़रूरी। कृपया इस ऑर्डर को पॉली बैग में डिलीवर करें।`}
        </Text>
      </View>
    ) : null;

  const isAllOrderMarkingSourceAPI = () => {
    if (
      onlinePaymentMetadata?.payment_status !== "FAILED" ||
      onlinePaymentMetadata?.payment_status !== "EXPIRED"
    )
      return false;
    if (
      Object.keys(orderMarkingSource).length === 0 ||
      Object.keys(orderMarkingSource).length < listData.length
    ) {
      return false;
    }
    let val = true;
    Object.values(orderMarkingSource).forEach((item) => {
      if (item !== "api") {
        val = false;
      }
    });
    return val;
  };

  return (
    <View style={styles.container}>
      <HeaderWithBackAndTitle
        headertitle={data?.user_name || t(`${PATH}/customer_orders`)}
        headerColor="#fff"
        hideShadow={false}
        navigation={navigation}
        route={route}
        alwaysEnable={true}
        goingBackHandler={
          multiDeliveryEnabled &&
          Object.keys(orderMarkingMap).length > 0 &&
          Object.values(orderMarkingMap).some(
            (item) =>
              item?.key === "CANCEL_DELIVERY" ||
              item?.key === "CONFIRM_DELIVERY",
          ) &&
          onlinePaymentMetadata?.is_marking_enabled
            ? backHandler
            : null
        }
        rightComponent={
          isRescheduledCp.current ? (
            <RescheduleRightComponent
              isRescheduled={isRescheduled}
              setRescheduledModal={setRescheduledModal}
            />
          ) : null
        }
        bottomComponent={
          allData?.should_deliver_tag && (
            <HeaderStrip should_deliver_tag={allData?.should_deliver_tag} />
          )
        }
      />
      {allData?.amount_to_collect_today > 0 && !multiDeliveryEnabled ? (
        <View style={styles.moneyBox}>
          <Text variant="body_text_1" style={{ color: color.plain_green }}>
            {t(`${PATH}/amount_to_collect`)}
          </Text>
          <Text
            variant="heading_24"
            // eslint-disable-next-line react-native/no-inline-styles
            style={{
              color: color.plain_green,
              fontSize: 32,
              marginTop: 10,
            }}
          >
            ₹ {Math.abs(allData?.amount_to_collect_today)}
          </Text>
        </View>
      ) : null}
      <View style={styles.container}>
        <FlatList
          data={listData}
          renderItem={({ item }) => renderItem({ item })}
          keyExtractor={(item) => item.card_id}
          keyboardShouldPersistTaps="handled"
          ListFooterComponent={footerComponent}
          onRefresh={onRefresh}
          refreshing={isRefreshing}
        />
        {showQrPaymentOption && !checkAllCxRTO() ? (
          <BottomPaymentSheet
            disable={
              isOrderMarkingMapEmpty() ||
              isMarking.current ||
              Object.keys(orderMarkingMap).length !== listData.length ||
              isAllOrderMarkingSourceAPI()
            }
            onPress={handlePaymentNavigation}
            amount={totalPayableAmount}
            online_payment_metadata={onlinePaymentMetadata}
            buttons={[
              { Icon: CashIcon, text: "कैश पेमेंट", paymentMode: "COD" },
              { Icon: QRIcon, text: "UPI पेमेंट", paymentMode: "PREPAID" },
            ]}
            handleNavigation={handleNavigation}
            refresh={onRefresh}
            allow_delivery_for_prepaid_orders={
              allData?.allow_delivery_for_prepaid_orders || checkAllCODCxRTO()
            }
            show_delivery_btn_post_payment={
              allData?.show_delivery_btn_post_payment
            }
            is_otp_enabled={allData?.otp_enabled}
            topAccessory={plasticBagBanner}
          />
        ) : allData?.show_delivery_submit_button && multiDeliveryEnabled ? (
          <BottomButton
            onPress={onSubmit}
            title={getSubmitBtnText()}
            amount={totalPayableAmount}
            showPaymentText={
              Object.keys(orderMarkingMap).length === listData.length &&
              !checkAllCxRTO()
            }
            loading={false}
            disable={
              isOrderMarkingMapEmpty() ||
              isProcessingRef.current ||
              Object.keys(orderMarkingMap).length !== listData.length ||
              isAllOrderMarkingSourceAPI()
            }
            topAccessory={plasticBagBanner}
          />
        ) : null}
        <Modal visible={isloading} transparent={true}>
          <View style={styles.loadingView}>
            <ActivityIndicator size="large" color={color.primary} />
          </View>
        </Modal>
        <RescheduleModal
          isPendingDMinus2={isPendingDMinus2}
          rescheduledModal={rescheduledModal}
          isRescheduled={isRescheduled}
          setRescheduledModal={setRescheduledModal}
          markingAction={markingAction}
          selectedAction={data.action}
          taskActionConfig={allData?.task_action_config}
        />
      </View>
      <MarkingDeliveryModal
        showModal={showMarkingModal}
        setShowModal={setShowMarkingModal}
        item={markingOrder}
        onMarkingOrder={onMarkingOrder}
        closemarkingModal={closemarkingModal}
      />
      <ConfirmationModalWithImage
        imageComponent={modalImage("submit")}
        text={
          !checkAllCxRTO()
            ? t(`${PATH}/submit_modal_text`)
            : t(`${PATH}/submit_modal_text_2`)
        }
        visible={showSubmitModal}
        setVisible={setShowSubmitModal}
        buttonText={[
          {
            text: t(`${PATH}/no`),
            type: "cancel",
            onPress: () => setShowSubmitModal(false),
          },
          {
            text: t(`${PATH}/yes`),
            type: "submit",
            onPress: handleNavigation,
          },
        ]}
      />
      <ConfirmationModalWithImage
        imageComponent={modalImage("cancel")}
        text={t(`${PATH}/cancle_modal_text`)}
        visible={showCancleMarkingModal}
        setVisible={setShowCancleMarkingModal}
        buttonText={[
          {
            text: t(`${PATH}/no`),
            type: "cancel",
            onPress: () => setShowCancleMarkingModal(false),
          },
          {
            text: t(`${PATH}/yes`),
            type: "submit",
            onPress: () => {
              dispatch(myTaskActions.clearOrderMarking());
              setShowCancleMarkingModal(false);
              navigation.pop();
            },
          },
        ]}
      />
      {showInstantCommissionModal && (
        <InstantCommissionModal
          isVisible={showInstantCommissionModal}
          onClose={() => {
            navigation.pop(1);
          }}
          commissionMsgs={commissionMsgs}
        />
      )}
    </View>
  );
}

export default CustomerOrdersView;

const styles = StyleSheet.create({
  plasticBagBanner: {
    backgroundColor: color.lightYellow,
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 8,
    marginBottom: 10,
  },
  plasticBagText: {
    color: color.light_text_yellow,
  },
  container: {
    flex: 1,
  },
  loadingView: {
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
  footer: {
    height: 200,
  },
  /* eslint-disable react-native/no-color-literals */
  moneyBox: {
    backgroundColor: "rgba(0, 171, 89, 0.05)",
    borderWidth: 1,
    borderRadius: 10,
    borderColor: color.plain_green,
    margin: 10,
    marginHorizontal: 16,
    alignItems: "center",
    padding: 12,
  },
  headerStrip: {
    flexDirection: "row",
    backgroundColor: "rgba(255, 249, 248, 1)",
    paddingVertical: 6,
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
    elevation: 1,
    alignContent: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  /* eslint-enable react-native/no-color-literals */
  headerText: {
    color: color.mediumBlacklightBlack,
    marginLeft: 8,
  },
});
